import AllEpisodesTable from './AllEpisodesTable';

export default AllEpisodesTable;
